import { Component, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'r1-compass-app-save-division-settings-footer',
    imports: [MatButtonModule],
    template: `
        <div class="footer-container">
            <button mat-flat-button color="primary" type="submit" [disabled]="disabled()">Save</button>
        </div>
    `,
    styles: `
        .footer-container {
            display: flex;
            justify-content: flex-end;
        }
    `,
})
export class SaveDivisionSettingsFooterComponent {
    disabled = input.required<boolean>();
}
